import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { IconComponent, IconNode } from '../icon/icon.component';

export interface TabBarItem {
  id: string;
  label: string;
  icon: IconNode;
}

/**
 * Barra inferior. Es `nav` con `aria-current`: a un lector de pantalla le dice qué sección está abierta,
 * que es lo que esta barra hace. No sabe de rutas: el shell conecta `select` con `IonTabs.select()`.
 * La pestaña activa se distingue por color y por peso, no sólo por color.
 */
@Component({
  selector: 'ui-tab-bar',
  imports: [IconComponent],
  template: `
    <nav class="bar" [attr.aria-label]="label()">
      @for (item of items(); track item.id) {
        <button
          type="button"
          class="tab"
          [class.active]="item.id === active()"
          [attr.aria-current]="item.id === active() ? 'page' : null"
          (click)="select.emit(item.id)"
        >
          <ui-icon [icon]="item.icon" size="1.5625rem" [strokeWidth]="1.9" />
          <span class="text">{{ item.label }}</span>
        </button>
      }
    </nav>
  `,
  styleUrl: './tab-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabBarComponent {
  readonly items = input.required<readonly TabBarItem[]>();
  readonly active = input<string | null>(null);
  readonly label = input('Principal');
  // eslint-disable-next-line @angular-eslint/no-output-native -- es el nombre que usa IonTabs.
  readonly select = output<string>();
}
